import { useEffect, useState } from 'react'
import { toast } from '@sales-center/components'

import { isAPIError } from '@user/store/services/crud'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

import { getAllCustomFieldsSettings } from '../api'
import { ENTITY_TYPES } from '@sales-center/common'

export function useGetCustomFieldsSettingsOnMount(entityType: ENTITY_TYPES) {
  const [loading, setLoading] = useState(false)

  const dispatch = useAppDispatch()

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      setLoading(true)
      const response = await dispatch(getAllCustomFieldsSettings(entityType))

      if (getAllCustomFieldsSettings.rejected.match(response)) {
        if (isAPIError(response.payload)) {
          toast.error(response.payload.Message)
        } else {
          toast.error('Failed to load Form Settings')
        }
      }

      if (mounted) setLoading(false)
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, entityType])

  return {
    loading,
  }
}
